module.exports = __webpack_public_path__ + "img/help-prediction.4c3b6035.webp";